module.exports = __webpack_public_path__ + "img/represent.cba2d0c0.svg";